<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getAppointments () {
    //   this.$store.dispatch('getAppointments')
    // },

    getUsers () {
      this.$store.dispatch('getUsers')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getAppointments()
      vm.getUsers()
      vm.getOffices()
      vm.getPrefs()
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Appointments.vue?53dfc0fc